function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "rename",
  fill: "#010101",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M10.9,0 C4.9,0 -1.50155444e-11,4.9 -1.50155444e-11,10.9 C-1.50155444e-11,15.1 2.3,18.7 5.8,20.5 L5.8,19.2 C3,17.5 1.2,14.4 1.2,10.9 C1.2,5.5 5.6,1.1 11,1.1 C16.4,1.1 20.8,5.5 20.8,10.9 C20.8,14.4 19,17.4 16.2,19.2 L16.2,20.5 C19.6,18.7 21.9,15 21.9,10.9 C21.8,4.9 17,0 10.9,0 Z M16.1,12.6 L17,12.6 C17.2,12.1 17.2,11.5 17.2,10.9 C17.2,7.4 14.4,4.6 10.9,4.6 C7.4,4.6 4.6,7.4 4.6,10.9 C4.6,11.5 4.7,12.1 4.8,12.6 L5.7,12.6 L6,12.6 C5.8,12.1 5.7,11.5 5.7,10.9 C5.7,8 8,5.7 10.9,5.7 C13.8,5.7 16.1,8 16.1,10.9 C16.1,11.5 16,12.1 15.8,12.6 L16.1,12.6 Z M10.8,8.4 L10.8,8.4 C9.4,8.4 8.2,9.5 8.2,11 L8.2,11 C8.2,12.4 9.3,13.6 10.8,13.6 L10.8,13.6 C12.2,13.6 13.4,12.5 13.4,11 L13.4,11 C13.3,9.5 12.2,8.4 10.8,8.4 Z M11.3,16.1 L10.1,16.1 L10.1,13.8 L7.7,13.8 C7.1,13.8 6.7,14.2 6.7,14.8 L6.7,23 L14.7,23 L14.7,14.8 C14.7,14.2 14.3,13.8 13.7,13.8 L11.3,13.8 L11.3,16.1 L11.3,16.1 Z",
  id: "solicitations-svg-icon"
})));

function SvgSolicitations(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "23px",
    viewBox: "0 0 22 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "JobOpps") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolicitations);
export default __webpack_public_path__ + "static/media/solicitations.e6fd5432.svg";
export { ForwardRef as ReactComponent };